import React, { useEffect, useState } from "react";
import IconCollection from "../../IconCollection/IconCollection";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import toast from "react-hot-toast";

import { useNavigate } from "react-router-dom";
import { submitPlayersAndMatchData, updateTeamOnePlayerPlayingStatus, updateTeamTwoPlayerPlayingStatus, gameSubs } from '../../redux/reducers/playersReducer';
import hexToRgb from '../../utils/hexToRgb';
import { baseApi } from '../../urlConfig';

const Starter = () => {
  const token = window.localStorage.getItem("token");
  const { quarter } = useSelector(state => state?.playersReducer)
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const playersReducer = useSelector(
    (state) => state?.playersReducer
  )
  const { teamOneColor, teamTwoColor,eventType } = playersReducer
  const matchData = playersReducer?.matchData

  const team_a_rosters = matchData?.team_a_rosters
  const team_b_rosters = matchData?.team_b_rosters

  const [teamOnePlayersPlaying, setTeamOnePlayersPlaying] = useState([]);

  const settingReducer = useSelector((state) => state.settingReducer);
  // const eventType = settingReducer.General.eventType;
  const { seconds, minutes } = settingReducer
  const maxPlayers = eventType === "5x5" ? 5 : 4;
  const isValidPlayingCount = (count) => {
    if (eventType === "5x5") return count === 5;
    return count === 3 || count === 4;
  };
  const [teamTwoPlayersPlaying, setTeamTwoPlayersPlaying] = useState([]);


  useEffect(() => {
    if (matchData?.team_a_rosters) {
      const isPlayerData = matchData?.team_a_rosters?.filter((player) => player.is_Playing === true)
      setTeamOnePlayersPlaying(isPlayerData)
    }
  }, [])
  useEffect(() => {
    if (matchData?.team_b_rosters) {
      const isPlayerData = matchData?.team_b_rosters?.filter((player) => player.is_Playing === true)
      setTeamTwoPlayersPlaying(isPlayerData)
    }
  }, [])
  const handleTeamOnePlayerPlaying = (roster_id, jersey_number) => {
    const playerIndex = teamOnePlayersPlaying?.findIndex(player => player.roster_id === roster_id);

    if (playerIndex === -1 && teamOnePlayersPlaying.length < maxPlayers) {

      setTeamOnePlayersPlaying(prevPlayers => [...prevPlayers, { roster_id, jersey_number, is_Playing: true }]);
    } else {

      setTeamOnePlayersPlaying(prevPlayers => {
        const updatedPlayers = prevPlayers.map(player => {
          if (player.roster_id === roster_id) {

            return {
              ...player,
              is_Playing: !player.is_Playing
            };
          }
          return player;
        });

        return updatedPlayers.filter(player => player.is_Playing);
      });
    }
  };





  const handleTeamTwoPlayerPlaying = (roster_id, jersey_number) => {
    const playerIndex = teamTwoPlayersPlaying.findIndex(player => player.roster_id === roster_id);

    if (playerIndex === -1 && teamTwoPlayersPlaying.length < maxPlayers) {
      // Player not found in the array and array length is less than 5, add it with is_Playing set to true
      setTeamTwoPlayersPlaying(prevPlayers => [...prevPlayers, { roster_id, jersey_number, is_Playing: true }]);
    } else {
      // Player found in the array, toggle its is_Playing status
      setTeamTwoPlayersPlaying(prevPlayers => {
        const updatedPlayers = prevPlayers.map(player => {
          if (player.roster_id === roster_id) {
            // Toggle is_Playing status
            return {
              ...player,
              is_Playing: !player.is_Playing
            };
          }
          return player;
        });
        // Remove players with is_Playing set to false
        return updatedPlayers.filter(player => player.is_Playing);
      });
    }
  };









  const [previousTeamOnePlayingStatus, setPreviousTeamOnePlayingStatus] =
    useState(null); // Variable to store previous playing status

  const [previousTeamTwoPlayingStatus, setPreviousTeamTwoPlayingStatus] =
    useState(null); // Variable to store previous playing status

  useEffect(() => {
    const previousTeamOnePlayers = matchData?.team_a_rosters?.filter(
      (player) => player.is_Playing
    );
    setPreviousTeamOnePlayingStatus(previousTeamOnePlayers);
  }, []);
  useEffect(() => {
    const previousTeamTwoPlayers = matchData?.team_b_rosters?.filter(
      (player) => player.is_Playing
    );
    setPreviousTeamTwoPlayingStatus(previousTeamTwoPlayers);
  }, []);


  const [teamTab, setTeamTab] = useState("team1");


  const [teamAPlayingCount, setTeamAPlayingCount] = useState(0);
  const [teamBPlayingCount, setTeamBPlayingCount] = useState(0);
  useEffect(() => {
    const teamAPlaying = matchData?.team_a_rosters?.filter(player => player.is_Playing).length;
    const teamBPlaying = matchData?.team_b_rosters?.filter(player => player.is_Playing).length;

    setTeamAPlayingCount(teamAPlaying);
    setTeamBPlayingCount(teamBPlaying);
  }, [matchData]);
  const handleGoToControlPage = () => {
    if (teamAPlayingCount && teamBPlayingCount) {

      navigate(`/control-page?eid=${matchData?.event_id}`)
    } else {
      toast.error(`Please select ${maxPlayers} players for each team`)
    }
  };

  const resetTeamOnePlaying = () => {
    if (teamOnePlayersPlaying.length > 0) {
      setTeamOnePlayersPlaying([])
    }
  };

  useEffect(() => {

  }, [])
  const [loadingOne, setLoadingOne] = useState(false)
  const [loadingTwo, setLoadingTwo] = useState(false)

  const setStarterBulk = async (t_id, rosterIds) => {
    try {
      const url = `${baseApi}/set_starter_bulk/`;
      const data = new FormData();
      data.append("event_id", matchData.event_id);
      data.append("eg_id", matchData.event_group_id);
      data.append("t_id", t_id);
      data.append("scorer_id", 1);
      
      // Append each roster_id as r_ids
      rosterIds.forEach((r_id) => {
        data.append("r_ids", r_id);
      });

      const response = await fetch(url, {
        method: "POST",
        headers: {
          'X-TOKEN': token,
        },
        body: data,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Failed to set starter bulk: ${response.status} ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error setting starter bulk:", error);
      throw error;
    }
  };

  const postTeamOneBulkSub = (t_id) => {
    if (isValidPlayingCount(teamOnePlayersPlaying.length)) {
      setLoadingOne(true);

      const url = `${process.env.REACT_APP_API_ROOT}` + "/api/add_subs_bulk/";
      const data = new FormData();
      data.append("score_timer", minutes * 60 + seconds);
      data.append("event_id", matchData.event_id);
      data.append("eg_id", matchData.event_group_id);
      data.append("t_id", t_id);
      data.append("score_period", quarter ? quarter : 'NotStarted');

      if (previousTeamOnePlayingStatus.length > 0) {
        previousTeamOnePlayingStatus.forEach((player, index) => {
          data.append(`r_id_${index + 1}_org`, player.roster_id);
        });
        teamOnePlayersPlaying.forEach((player, index) => {
          data.append(`r_id_${index + 1}_new`, player.roster_id);
        });
      } else {
        teamOnePlayersPlaying.forEach((player, index) => {
          data.append(`r_id_${index + 1}_org`, player.roster_id);
        });
        teamOnePlayersPlaying.forEach((player, index) => {
          data.append(`r_id_${index + 1}_new`, player.roster_id);
        });
      }

      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 20000);

      fetch(url, {
        method: "POST",
        body: data,
        headers: {
          Authorization: `${token}`,
        },
        signal: controller.signal
      })
        .then((response) => response.json())
        .then(async (data) => {
          clearTimeout(timeoutId);
          
          // Only on first-time: check if this specific team has any game_subs entries
          const hasExistingGameSubsForTeam = matchData?.game_subs?.some(
            (sub) => sub.t_id === matchData?.event_team_a_id
          ) || false;
          
          if (!hasExistingGameSubsForTeam) {
            const rosterIds = teamOnePlayersPlaying.map(player => player.roster_id);
            try {
              await setStarterBulk(t_id, rosterIds);
            } catch (error) {
              console.error("Error setting starter bulk for team one:", error);
              toast.error("Failed to set starters. Please try again.");
              setLoadingOne(false);
              return;
            }
          }
          
          dispatch(updateTeamOnePlayerPlayingStatus([...teamOnePlayersPlaying]));
          dispatch(gameSubs(data.game_data.game_subs));
          setLoadingOne(false);
          toast.success(`Team ${matchData?.team_a_short_name} Player Added Successfully`);
        })
        .catch((error) => {
          clearTimeout(timeoutId);
          setLoadingOne(false);
          if (error.name === 'AbortError') {
            toast.error('Request timed out. Please try again.');
          } else {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again.");
          }
        });
    }
  };


  const teamOneStartingLineUp = [];


  const handleTeamOnePlayerStartingLineUp = () => {
    if (isValidPlayingCount(teamOnePlayersPlaying.length)) {
      const startingLineupPlayers = team_a_rosters?.filter(player => player.is_startinglinup === true) || [];
      teamOnePlayersPlaying.forEach(player => {
        if (!teamOneStartingLineUp.some(existingPlayer => existingPlayer.r_id == player.roster_id)) {
          const newPlayer = {
            r_id: player.roster_id,
            t_id: matchData?.event_team_a_id,
            event_id: matchData?.event_id,
            eg_id: matchData?.event_group_id,
            present: true,
            startinglinup: true,
            play_sec: 0,
          };
          teamOneStartingLineUp.push(newPlayer);
        }
      });
      startingLineupPlayers.forEach(player => {
        if (!teamOnePlayersPlaying.some(existingPlayer => existingPlayer.roster_id == player.roster_id)) {
          const newPlayer = {
            r_id: player.roster_id,
            t_id: matchData?.event_team_a_id,
            event_id: matchData?.event_id,
            eg_id: matchData?.event_group_id,
            present: true,
            startinglinup: false,
            play_sec: 0,
          };
          teamOneStartingLineUp.push(newPlayer);
        }
      });
      const formdata = new FormData();
      formdata.append("data", JSON.stringify([
        ...teamOneStartingLineUp
      ]));
      try {
        const response = axios.post(
          `${process.env.REACT_APP_API_ROOT}` + "/api/playerStatus/", formdata,
          {
            headers: {
              "Authorization": `${token}`,
            },
          }
        );

        if (response.data.data !== null) {


          dispatch(submitPlayersAndMatchData(response.data.data));


        }
      } catch (error) {
        console.error("Error submitting team one data:", error);
      }

    } else {
      toast.error(`Please select Team ${matchData?.team_a_name} Stater ${eventType === "5x5" ? 5 : "3 or 4"} Player`);
    }

  };



  const teamTwoStartingLineUp = [];
  const handleTeamTwoPlayerStartingLineUp = () => {
    if (isValidPlayingCount(teamTwoPlayersPlaying.length)) {
      const startingLineupPlayers = team_b_rosters?.filter(player => player.is_startinglinup === true) || [];
      teamTwoPlayersPlaying.forEach(player => {
        if (!teamTwoStartingLineUp.some(existingPlayer => existingPlayer.r_id == player.roster_id)) {
          const newPlayer = {
            r_id: player.roster_id,
            t_id: matchData?.event_team_b_id,
            event_id: matchData?.event_id,
            eg_id: matchData?.event_group_id,
            present: true,
            startinglinup: true,
            play_sec: 0,
          };
          teamTwoStartingLineUp.push(newPlayer);
        }
      });
      startingLineupPlayers.forEach(player => {
        if (!teamTwoPlayersPlaying.some(existingPlayer => existingPlayer.roster_id == player.roster_id)) {
          const newPlayer = {
            r_id: player.roster_id,
            t_id: matchData?.event_team_b_id,
            event_id: matchData?.event_id,
            eg_id: matchData?.event_group_id,
            present: true,
            startinglinup: false,
            play_sec: 0,
          };
          teamTwoStartingLineUp.push(newPlayer);
        }
      });
      const formdata = new FormData();
      formdata.append("data", JSON.stringify([
        ...teamTwoStartingLineUp
      ]));
      try {
        const response = axios.post(
          `${process.env.REACT_APP_API_ROOT}` + "/api/playerStatus/", formdata,
          {
            headers: {
              "Authorization": `${token}`,
            },
          }
        );

        if (response.data.data !== null) {

          dispatch(submitPlayersAndMatchData(response.data.data));


        }
      } catch (error) {
        console.error("Error submitting team one data:", error);
      }

    } else {
      toast.error(`Please select Team ${matchData?.team_b_name} Starter ${eventType === "5x5" ? 5 : "3 or 4"} Player`);
    }


  };



  const resetTeamTwoPlaying = () => {
    if (teamTwoPlayersPlaying.length > 0) {
      setTeamTwoPlayersPlaying([])
    }
  };
  const postTeamTwoBulkSub = (t_id) => {
    if (isValidPlayingCount(teamTwoPlayersPlaying.length)) {
      setLoadingTwo(true);

      const url = `${process.env.REACT_APP_API_ROOT}` + "/api/add_subs_bulk/";
      const data = new FormData();
      data.append("score_timer", minutes * 60 + seconds);
      data.append("event_id", matchData.event_id);
      data.append("eg_id", matchData.event_group_id);
      data.append("t_id", t_id);
      data.append("score_period", quarter ? quarter : 'NotStarted');

      if (previousTeamTwoPlayingStatus.length > 0) {
        previousTeamTwoPlayingStatus.forEach((player, index) => {
          data.append(`r_id_${index + 1}_org`, player.roster_id);
        });
        teamTwoPlayersPlaying.forEach((player, index) => {
          data.append(`r_id_${index + 1}_new`, player.roster_id);
        });
      } else {
        teamTwoPlayersPlaying.forEach((player, index) => {
          data.append(`r_id_${index + 1}_org`, player.roster_id);
        });
        teamTwoPlayersPlaying.forEach((player, index) => {
          data.append(`r_id_${index + 1}_new`, player.roster_id);
        });
      }

      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 20000);

      fetch(url, {
        method: "POST",
        body: data,
        headers: {
          Authorization: `${token}`,
        },
        signal: controller.signal
      })
        .then((response) => response.json())
        .then(async (data) => {
          clearTimeout(timeoutId);
          
          // Only on first-time: check if this specific team has any game_subs entries
          const hasExistingGameSubsForTeam = matchData?.game_subs?.some(
            (sub) => sub.t_id === matchData?.event_team_b_id
          ) || false;
          
          if (!hasExistingGameSubsForTeam) {
            const rosterIds = teamTwoPlayersPlaying.map(player => player.roster_id);
            try {
              await setStarterBulk(t_id, rosterIds);
            } catch (error) {
              console.error("Error setting starter bulk for team two:", error);
              toast.error("Failed to set starters. Please try again.");
              setLoadingTwo(false);
              return;
            }
          }
          
          dispatch(updateTeamTwoPlayerPlayingStatus([...teamTwoPlayersPlaying]));
          dispatch(gameSubs(data.game_data.game_subs));
          setLoadingTwo(false);
          toast.success(`Team ${matchData.team_b_short_name} Player Added Successfully`);
        })
        .catch((error) => {
          clearTimeout(timeoutId);
          setLoadingTwo(false);
          if (error.name === 'AbortError') {
            toast.error('Request timed out. Please try again.');
          } else {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again.");
          }
        });
    }
  };



  const goBack = () => {
    navigate(-1);
  };



  const activeTeamOneColor = hexToRgb(teamOneColor);
  const activeTeamTwoColor = hexToRgb(teamTwoColor);

  return (
    <div className='max-w-[1512px] w-full px-0 lg:px-6 mx-auto py-4 flex justify-between items-center'>


      <div className='w-full h-auto'>
        <div className='font-bebas text-xl md:text-3xl px-2 md:px-6 pt-1 md:py-4'>
          Starter/Active Players and Substitution
        </div>
        <div className="h-[56px] w-full flex justify-center items-center gap-2 md:gap-10 px-0 lg:px-12 ">
          <button
            onClick={() => setTeamTab("team1")}
            className={`font-rubik  cursor-pointer text-base md:text-xl px-1 md:px-5 py-[2px] md:py-3 ${teamTab == "team1"
              ? "text-primary font-medium"
              : "text-[#7D7D7D] font-normal"
              }`}
          >
            {matchData?.team_a_short_name}
          </button>
          <button
            onClick={() => setTeamTab("team2")}
            className={`font-rubik  cursor-pointer text-base md:text-xl px-1 md:px-5 py-[2px] md:py-3 ${teamTab == "team2"
              ? "text-primary font-medium"
              : "text-[#7D7D7D] font-normal"
              }`}
          >
            {matchData?.team_b_short_name}
          </button>
        </div>
        <div className="w-full h-[1px] bg-[#E8E8E8]"></div>
        <div className="px-1 lg:px-12 py-1 md:py-5 pb-0">
          {teamTab === "team1" && (
            <div className="flex flex-col gap-4 md:gap-12">
              <div className="flex flex-col gap-4 md:flex-row items-center justify-between relative">

                <p className="text-[#4A4A4A] md:text-[32px] font-bebas">STARTER/ACTIVE</p>


                <div className="flex gap-2 items-center relative h-[56px] md:h-[148px]">
                  <div className='absolute right-0 flex gap-2 items-center'>
                    {[...Array(maxPlayers)].map((_, index) => (
                      <button className={`relative md:w-[108.26px] w-[44px]   md:h-[148px] h-[60.15px] cursor-pointer `}>
                        <IconCollection
                          name="player-jersey-white"
                          customClass='md:w-[108.26px] w-[44px] w-full md:h-[148px] h-[60.15px]'
                          svgFillColor={teamOneColor}
                        />
                        <div className='absolute md:top-[115px] top-[46px] right-0 left-0 justify-center flex md:gap-[2px] gap-[.81px] items-center'>
                          {[...Array(5)].map((_, index) => (
                            <div
                              key={index}
                              className={`border-[.67px] rounded-full
                              md:w-2 md:h-2 w-[3.25px] h-[3.25px]`

                              }
                            ></div>
                          ))}
                        </div>
                      </button>
                    ))}

                  </div>
                  {teamOnePlayersPlaying.length > 0 &&
                    teamOnePlayersPlaying
                      .filter((player) => player.is_Playing === true)
                      .sort((a, b) => a.jersey_number - b.jersey_number) // Sort players by jersey_number
                      .map((player) => (
                        <button
                          key={player.roster_id}
                          className={`relative md:max-w-[108.26px] max-w-[44px]  w-full md:h-[148px] h-[60.15px] cursor-pointer `}
                        >
                          <IconCollection
                            name="player-jersey-white"
                            customClass='md:w-[108.26px] w-[44px] w-full md:h-[148px] h-[60.15px]'
                            svgFillColor={teamOneColor}
                          />
                          {player?.captain && (
                            <div className="absolute top-[7px] md:top-[16px] right-4 md:right-[43px] font-bebas text-[8px] md:text-xs bg-white rounded-full md:h-5 md:w-5 h-3 w-3 leading-none flex justify-center items-center">
                              c
                            </div>
                          )}
                          <p
                            className={`font-bebas md:text-[64px] text-[28px] text-white absolute md:top-[20px] top-[12px] right-0 left-0 text-center `}
                          >
                            {player.jersey_number}
                          </p>
                          <div className='absolute md:top-[115px] top-[46px] right-0 left-0 justify-center flex md:gap-[2px] gap-[.81px] items-center'>
                            {[...Array(5)].map((_, index) => (
                              <div
                                key={index}
                                className={`border-[.67px] rounded-full md:w-2 md:h-2 w-[3.25px] h-[3.25px]`}
                              ></div>
                            ))}
                          </div>
                        </button>
                      ))
                  }

                </div>
              </div>
              <div className="flex gap-4 flex-col md:flex-row items-center justify-between">
                <p className="text-[#4A4A4A] text-xl md:text-[32px] font-bebas">Bench</p>
                <div className="max-w-[90%] md:max-w-[504px] w-full  flex flex-wrap items-center gap-2 md:gap-4">
                  {matchData?.team_a_rosters && [...matchData?.team_a_rosters].sort((a, b) => a.jersey_number - b.jersey_number).map((player) => (
                    <button
                      key={player.roster_id}
                      disabled={!player?.is_present}
                      onClick={() => handleTeamOnePlayerPlaying(player.roster_id, player.jersey_number)}
                      className={`w-10 disabled:bg-gray-300 md:w-[88px] text-light font-bebas text-lg md:text-[64px] h-10 md:h-[88px] rounded-sm md:rounded-lg flex relative justify-center items-center `}


                      style={{
                        backgroundColor: player.roster_id && teamOnePlayersPlaying.some(item => item.roster_id === player.roster_id)
                          ? activeTeamOneColor
                          : teamOneColor
                      }}

                    >

                      {
                        player?.captain && (
                          <div className="absolute top-[3px] md:top-[3px] text-black right-[16px] md:right-[36px] font-bebas text-[5px] md:text-[8px] bg-white rounded-full md:h-3 md:w-3 h-[6px] w-[6px] leading-none flex justify-center items-center">
                            c
                          </div>
                        )
                      }

                      {player.jersey_number}
                      <div className="flex  gap-[2px] items-center absolute bottom-2">
                        {[...Array(5)].map((_, index) => (
                          <div
                            key={index}
                            className={`border-[.67px] rounded-full md:w-2 md:h-2 w-[3.25px] h-[3.25px]`}
                          ></div>
                        ))}
                      </div>
                    </button>
                  ))}
                </div>
              </div>
              <div className="h-[48px] md:h-[80px] w-full px-2 lg:px-12 border-[#E8E8E8] border-t-[1px] flex justify-between items-center">
                <button
                  onClick={() => resetTeamOnePlaying()}
                  className="text-primary font-montserrat text-xs md:text-base font-medium"
                >
                  Reselect Starter
                </button>
                <div className="flex items-center gap-3 md:gap-6 max-w-[246px] md:max-w-[440px] w-full justify-end">
                  <button
                    onClick={() => goBack()}
                    className="max-w-[60px] md:max-w-[108px] w-full h-6 md:h-12 rounded-sm md:rounded flex justify-center items-center bg-[#E8E8E8] font-bebas text-xs md:text-base text-black disabled:text-white disabled:bg-gray-100"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => {
                      postTeamOneBulkSub(matchData?.event_team_a_id);
                      handleTeamOnePlayerStartingLineUp();
                    }}
                    disabled={!teamOnePlayersPlaying.length == maxPlayers}
                    className="max-w-[60px] md:max-w-[108px] w-full  h-6 md:h-12 rounded-sm md:rounded flex justify-center items-center bg-primary font-bebas text-xs md:text-base text-light disabled:text-white disabled:bg-gray-100"
                  >
                    {loadingOne ? "Saving..." : 'save'}
                  </button>
                  <button
                    className=" max-w-fit  h-6 md:h-12 px-2 items-center rounded-sm md:rounded bg-primary font-bebas text-light text-xs md:text-base disabled:text-white disabled:bg-gray-100"
                    onClick={handleGoToControlPage}

                  >
                    Go to Control Page
                  </button>
                </div>
              </div>
            </div>
          )}
          {teamTab === "team2" && (
            <div className="flex flex-col gap-4 md:gap-12">
              <div className="flex gap-4 flex-col md:flex-row items-center justify-between relative">

                <p className="text-[#4A4A4A] md:text-[32px] font-bebas">STARTER/ACTIVE</p>
                <div className="flex gap-2 items-center relative h-[56px] md:h-[148px]">
                  <div className='absolute right-0 flex gap-2 items-center'>
                    {[...Array(maxPlayers)].map((_, index) => (
                      <button className='relative max-w-[108.26px] w-full h-[56px] md:h-[148px] cursor-pointer'>
                        <IconCollection
                          name="player-jersey-white"
                          customClass='md:w-[108.26px] w-[44px] w-full md:h-[148px] h-[60.15px]'
                          svgFillColor={teamTwoColor}
                        />
                        <div className="absolute md:top-[115px] top-[46px] right-0 left-0 justify-center flex md:gap-[2px] gap-[.81px] items-center">
                          {[...Array(5)].map((_, index) => (
                            <div
                              key={index}
                              className={`border-[.67px] rounded-full
                                md:w-2 md:h-2 w-[3.25px] h-[3.25px]`}
                            ></div>
                          ))}
                        </div>
                      </button>
                    ))}


                  </div>

                  {teamTwoPlayersPlaying.length > 0 &&
                    teamTwoPlayersPlaying
                      .filter((player) => player.is_Playing === true)
                      .sort((a, b) => a.jersey_number - b.jersey_number) // Sort players by jersey_number
                      .map((player, i) => (
                        <button
                          key={i}
                          className={`relative md:max-w-[108.26px] max-w-[44px]  w-full md:h-[148px] h-[60.15px] cursor-pointer `}
                        >
                          <IconCollection
                            name="player-jersey-white"
                            customClass='md:w-[108.26px] w-[44px] w-full md:h-[148px] h-[60.15px]'
                            svgFillColor={teamTwoColor}
                          />
                          {
                            player?.captain && (
                              <div className="absolute top-[7px] md:top-[16px] right-4 md:right-[43px] font-bebas text-[8px] md:text-xs bg-white rounded-full md:h-5 md:w-5 h-3 w-3 leading-none flex justify-center items-center">
                                c
                              </div>
                            )
                          }
                          <p
                            className={`font-bebas md:text-[64px] text-[28px] text-white absolute md:top-[20px] top-[12px] right-0 left-0 text-center `}
                          >
                            {player.jersey_number}
                          </p>
                          <div className='absolute md:top-[115px] top-[46px] right-0 left-0 justify-center flex md:gap-[2px] gap-[.81px] items-center'>
                            {[...Array(5)].map((_, index) => (
                              <div
                                key={index}
                                className={`border-[.67px] rounded-full md:w-2 md:h-2 w-[3.25px] h-[3.25px]`}
                              ></div>
                            ))}
                          </div>
                        </button>
                      ))
                  }
                </div>
              </div>
              <div className="flex gap-4 flex-col md:flex-row items-center justify-between">
                <p className="text-[#4A4A4A] text-xl md:text-[32px] font-bebas">Bench</p>
                <div className="max-w-[90%] md:max-w-[504px] w-full  flex flex-wrap items-center gap-4">
                  {[...matchData?.team_b_rosters]?.sort((a, b) => a.jersey_number - b.jersey_number).map((player) => (
                    <button
                      key={player.roster_id}
                      // onClick={() => handleTeamTwoBulkSubSelect(player.roster_id)}
                      disabled={!player?.is_present}
                      onClick={() => handleTeamTwoPlayerPlaying(player.roster_id, player.jersey_number)}
                      className={`w-10 md:w-[88px] text-light font-bebas text-lg md:text-[64px] h-10 md:h-[88px] rounded-sm md:rounded-lg flex relative justify-center items-center disabled:bg-gray-300 `}


                      style={{
                        backgroundColor: player.roster_id && teamTwoPlayersPlaying.some(item => item.roster_id === player.roster_id)
                          ? activeTeamTwoColor
                          : teamTwoColor
                      }}


                    >
                      {
                        player?.captain && (
                          <div className="absolute top-[3px] md:top-[3px] text-black right-[16px] md:right-[36px] font-bebas text-[5px] md:text-[8px] bg-white rounded-full md:h-3 md:w-3 h-[6px] w-[6px] leading-none flex justify-center items-center">
                            c
                          </div>
                        )
                      }

                      {player.jersey_number}
                      <div className="flex  gap-[2px] items-center absolute bottom-2">
                        {[...Array(5)].map((_, index) => (
                          <div
                            key={index}
                            className={`border-[.67px] rounded-full md:w-2 md:h-2 w-[3.25px] h-[3.25px]`}
                          ></div>
                        ))}
                      </div>
                    </button>
                  ))}
                </div>
              </div>
              <div className="h-[48px] md:h-[80px] w-full px-2 lg:px-12 border-[#E8E8E8] border-t-[1px] flex justify-between items-center">
                <button
                  onClick={() => resetTeamTwoPlaying()}
                  className="text-primary font-montserrat text-xs md:text-base font-medium"
                >
                  Reselect Starter
                </button>
                <div className="flex items-center gap-3 md:gap-6 max-w-[246px] md:max-w-[440px] w-full justify-end">
                  <button
                    onClick={() => goBack()}
                    // disabled={matchData?.team_b_rosters?.filter(player => player.is_Playing).length === 0}
                    className="max-w-[60px] md:max-w-[108px] w-full h-6 md:h-12 rounded-sm md:rounded flex justify-center items-center bg-[#E8E8E8] font-bebas text-xs md:text-base text-black disabled:text-white disabled:bg-gray-100"
                  >
                    Cancel
                  </button>

                  <button
                    onClick={() => {
                      postTeamTwoBulkSub(matchData.event_team_b_id);
                      handleTeamTwoPlayerStartingLineUp();
                    }}
                    // disabled={teamTwoPlayersPlaying.length !== maxPlayers}
                    className="max-w-[60px] md:max-w-[108px] w-full h-6 md:h-12 rounded-sm md:rounded flex justify-center items-center bg-primary font-bebas text-xs md:text-base text-light disabled:text-white disabled:bg-gray-100"
                  >
                    {loadingTwo ? "Saving..." : 'save'}
                  </button>

                  <button
                    className=" max-w-fit  h-6 md:h-12 px-2 items-center rounded-sm md:rounded bg-primary font-bebas text-light text-xs md:text-base disabled:text-white disabled:bg-gray-100"
                    onClick={handleGoToControlPage}

                  >
                    Go to Control Page
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Starter;
